import React from "react";
import { Icon, Button } from "../../Component";

const MedicalPartnerListEmptyState = ({ activeTab, hasListFilters, openAddPartnerModal, loading }) => (
  <div className="text-center p-5">
    <Icon name="users" size="64px" className="text-soft mb-3" />
    <h5 className="mb-2">
      {activeTab === "pending"
        ? "No pending requests"
        : activeTab === "active"
        ? "No live partner"
        : "No partner found"}
    </h5>
    <p className="text-soft mb-4">
      {activeTab === "pending"
        ? "All requests have been processed"
        : activeTab === "active"
        ? "No partner is currently live in workflow"
        : hasListFilters
        ? "No partner matches your search or filters"
        : "Create your first medical partner"}
    </p>
    {activeTab === "all" && !hasListFilters ? (
      <Button
        type="button"
        color="primary"
        onClick={openAddPartnerModal}
        disabled={loading}
        title="New partner: primary user first, then organization"
      >
        <Icon name="plus" />
        <span>New partner</span>
      </Button>
    ) : null}
  </div>
);

export default MedicalPartnerListEmptyState;
